import {StyleSheet} from 'aphrodite';

const styles = StyleSheet.create({
    placeholderMargin: {
        marginBottom: 15
    }
});

export default styles;
